<template>
  <div
    class="avatar-container"
    :class="{ ' has-notification': user.notificationCount }"
    data-hj-suppress
  >
    <slot />
  </div>
</template>

<script>
/*
Powers the unread notification dot on User Avatar in Nav
data-hj-suppress = hide from hotjar screen recordings
*/

// @flow
import { mapState } from 'vuex'

export default {
  name: 'UnreadNotificationDot',
  props: {},
  data() {
    return {}
  },

  computed: {
    ...mapState(['user']),
  },
}
</script>
